import InvisiButton from '../InvisiButton/InvisiButton'
import type { ReactNode } from 'react'

export interface Props {
  title?: string
  textToCopy: string
  children: ReactNode
  onClick?: () => void
  hasBackgroundColor?: boolean
}

const CopyTextToClipboard = (value: string) => {
  void navigator.clipboard.writeText(value)
}

const CopyToClipboard = ({
  title = 'Click to copy to clipboard',
  textToCopy,
  children,
  onClick,
  hasBackgroundColor = true
}: Props) => {
  const handleClickToCopy = () => {
    CopyTextToClipboard(textToCopy)

    if (onClick) onClick()
  }

  return (
    <InvisiButton
      hasBackgroundColor={hasBackgroundColor}
      hasPadding={false}
      onClick={handleClickToCopy}
      title={title}
    >
      {children}
    </InvisiButton>
  )
}

export default CopyToClipboard
